function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire88f1"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire88f1"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $ca2206752412dde1$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"h00hi":"index.dfb76dc4.js","i7vBv":"concrete_tile_color.53c3ddf6.jpg","h8hTp":"concrete_tile_normal.d30a38eb.jpg","bnyQU":"concrete_tile_rough.3c0ea372.jpg","i6iJb":"Water_1_M_Normal.9134fbee.jpg","bhJWJ":"Water_2_M_Normal.146eabd2.jpg","3vZYQ":"Water_1_M_Flow.ebe5a327.jpg","jwBOd":"poolwood_abledo.963acdc9.jpg","ebVdJ":"poolwood_norm.64a1b7a3.png","1ucOX":"poolwood_spec.d2be2acd.png","2Hvr6":"grass_BaseColor.a8f19876.jpg","fklN9":"grass_Normal.37c87cf6.jpg","43mYS":"grass_Roughness.ed826e40.jpg","bjKwr":"grass_AO.63139870.png","dxY3c":"mud_leaves_color.67eb1189.jpg","2X60r":"mud_leaves_normal.69ca16a2.jpg","isYAp":"mud_leaves_rough.e391467a.jpg","Pfn5O":"plant1_color.e8fdc923.jpg","kdzwV":"plant1_normal.f2124bdb.jpg","baIMz":"plant1_rough.c69e1cd2.jpg","aARnF":"plant2_color.62ffc6d6.jpg","i6a3m":"plant2_normal.08244ab6.jpg","9P5Ix":"plant2_rough.73a0dc12.jpg","fAxUY":"sky6.7f67dbd6.hdr","dspne":"sky-night.3cd9486d.hdr","6qoUX":"plant1.02b9db0a.fbx","4jArP":"plant2.e72a074a.fbx","561NU":"plant6.bdaf4ee8.fbx","aHiUg":"relax.f913b5e9.fbx","1ApdJ":"relax2.25c27b04.fbx","iHBVq":"spot.286cacd6.fbx","cVXmp":"skimmer.b6cfd6d8.fbx","3eBXE":"sofa.16c8de2e.fbx","2Qgny":"sofa_single.bd490f89.fbx","btQrd":"pot1.02d139b9.fbx","lM4xP":"grass2.fe93049e.fbx","hHHOP":"parasol.13883bb6.fbx","6PJ4K":"caustics.f7735f7a.png"}'));


//# sourceMappingURL=index.42b33663.js.map
